import { toast } from "react-toastify";
import { genericError } from "../Constants";

//gete rror from http response
export const getErrorMessageFromHtttpResponse = (response) => {
  let errrors = getErrorsArrayMessageFromHtttpResponse(response);
  return errrors[0];
};

//alert a toast error from http response
export const alertToastErrorFromResponse = async (message, response) => {
  toast.error(`${message} ${getErrorMessageFromHtttpResponse(response)}`);
};

//used in await response from api call and return an array of errors
export const getErrorsArrayMessageFromHtttpResponse = (response) => {
  let errorArray = ["Error desconocido"];

  if (response?.statusText != undefined) errorArray = [response?.statusText];

  if (response?.message != undefined) errorArray = [response?.message];

  if (response?.data?.message != undefined)
    errorArray = [response?.data?.message];

  if (response?.data?.errors && response?.data?.errors.length > 0)
    errorArray = response?.data?.errors;

  if (response?.errors && response?.errors.length > 0)
    errorArray = response?.errors;

  return errorArray;
};

//used in axios eror cahtch
export const parseResponseError = (error) => {
  let response = { message: genericError };
  if (error?.response) {
    response = error.response;
  }
  return response;
};

export const formHasErrors = (errors) => {
  return Object.keys(errors).length > 0;
};
